/**
 * Impact Theme Custom JS
 * 1. Hover Slide Animation
 * 2. External Link Handler
 * 3. Global Lifecycle Manager
 */

(function () {
    // 1. Hover Slide Animation
    const initHoverSlide = () => {
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (isTouchDevice) return;
        document.querySelectorAll("a:not([disabled]), button:not([disabled])").forEach((element) => {
            if (element.dataset.hoverSlideInit) return;
            element.dataset.hoverSlideInit = "true";
            const hoverSlideDiv = element.querySelector(".hover-slide");
            if (!hoverSlideDiv) return;
            const span = hoverSlideDiv.querySelector("span");
            if (!span) return;
            let isAnimating = false;
            let cloneSpan = null;
            const startAnimation = () => {
                if (isAnimating || element.hasAttribute('disabled')) return;
                isAnimating = true;
                const spanRect = span.getBoundingClientRect();
                const hoverSlideDivRect = hoverSlideDiv.getBoundingClientRect();
                cloneSpan = span.cloneNode(true);
                cloneSpan.style.position = "absolute";
                cloneSpan.style.left = `${spanRect.left - hoverSlideDivRect.left}px`;
                cloneSpan.style.top = `${spanRect.top - hoverSlideDivRect.top}px`;
                cloneSpan.style.width = `${spanRect.width}px`;
                cloneSpan.style.height = `${spanRect.height}px`;
                cloneSpan.style.transform = "translateY(100%)";
                cloneSpan.style.transition = "transform 0.6s cubic-bezier(0.4, 0, 0, 1)";
                hoverSlideDiv.appendChild(cloneSpan);
                span.style.transform = "translateY(-100%)";
                span.style.transition = "transform 0.6s cubic-bezier(0.4, 0, 0, 1)";
                setTimeout(() => { requestAnimationFrame(() => { if (cloneSpan) cloneSpan.style.transform = "translateY(0)"; }); }, 50);
            };
            const resetAnimation = () => {
                if (!isAnimating) return;
                span.style.transform = "translateY(0)";
                if (cloneSpan) {
                    cloneSpan.style.transform = "translateY(100%)";
                    cloneSpan.addEventListener("transitionend", () => {
                        if (cloneSpan) { cloneSpan.remove(); cloneSpan = null; }
                        isAnimating = false;
                    }, { once: true });
                } else { isAnimating = false; }
            };
            element.addEventListener("mouseenter", startAnimation, false);
            element.addEventListener("mouseleave", resetAnimation, false);
        });
    };

    // 2. External Link Handler
    const initExternalLinks = () => {
        document.querySelectorAll('a[href^="http"], a[href^="/"]').forEach(link => {
            if ((link.protocol === 'http:' || link.protocol === 'https:') && link.hostname !== window.location.hostname) {
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                link.setAttribute('data-external', 'true');
            }
        });
    };

    // 3. Global Lifecycle Manager
    function mainInit() {
        initHoverSlide();
        initExternalLinks();
    }

    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", mainInit); } else { mainInit(); }
    document.addEventListener("shopify:section:load", mainInit);

    window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
            document.querySelectorAll('[data-hover-slide-init]').forEach(el => {
                delete el.dataset.hoverSlideInit;
            });
            mainInit();
        }
    });
})();